import {UserInfoInterface} from 'common/types/store/userTypes';
import {ROUTES_USER_ACCESS_MAPPING, USER_ACCESS} from './constants';
import {ROUTES} from 'common/constants';


export default class PermissionManager {
	private _user: UserInfoInterface;

	constructor(user: UserInfoInterface) {
		this._user = user;
	}

	getRequiredRoles(route: string): string[] {
		// Flatten the array of arrays to a single array of roles
		const mapping = ROUTES_USER_ACCESS_MAPPING[route];
		if (!mapping) return [];
		return mapping.flat();
	}

	hasAccess(route: string): boolean {
		const requiredRoles = this.getRequiredRoles(route);
		return requiredRoles.some(role => this._user.roles.includes(role));
	}

	getDefaultRoute(userConfigRoute?: string): string {
		// If user has no roles, go to unauthorized
		if (!this._user.roles || this._user.roles.length === 0) {
			return ROUTES.UNAUTHORIZED_USER;
		}

		// If user has a saved preference and has access to it, use it
		if (userConfigRoute && this.hasAccess(userConfigRoute)) {
			return userConfigRoute;
		}

		// Check access in priority order
		if (this._user.roles.some(role => USER_ACCESS.BMODASHBOARD.includes(role))) {
			return ROUTES.BMODASHBOARD;
		}
		if (this._user.roles.some(role => USER_ACCESS.MRC.includes(role))) {
			return ROUTES.MRC;
		}
		if (this._user.roles.some(role => USER_ACCESS.THREE_SIXTY.includes(role))) {
			return ROUTES.THREE_SIXTY;
		}
        
		// Fallback to profile if user has roles but none of the above
		return ROUTES.PROFILE;
	}
}